import { Row } from '@innovamat/glimmer-components';
import { StudentIntervention } from '@innovamat/glow-api-client';

export const getStudentsRowsCatchUp = (
  catchUpDashboardData: StudentIntervention[]
): Row[] => {
  return catchUpDashboardData.filter((s: any) => s.firstName);
};
